import React from 'react';
import { Box, Chip, useMediaQuery, useTheme } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { filterLabels } from '../constants';
import usePremiumBacklink from '../hooks/usePremiumBacklink';

const AppliedFilters = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { filters, handleFilterChange, clearFilters } = usePremiumBacklink();

  const getFilterValue = (key, value) => value;

  const activeFilters = Object.entries(filters).filter(([, value]) => 
    value !== '' && value !== null && value !== undefined
  );

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexWrap="wrap" mb={2} gap={isMobile ? '4px' : '6px'}>
      {activeFilters.map(([key, value]) => (
        <Chip
          key={key}
          label={`${filterLabels[key]}: ${getFilterValue(key, value)}`}
          onDelete={() => handleFilterChange({ [key]: '' })}
          deleteIcon={<ClearIcon />}
          style={{
            backgroundColor: '#D3DFE8', 
            color: 'white',
            height: isMobile ? 22 : 25,
            fontSize: isMobile ? '0.7rem' : '0.8125rem',
            marginRight: '4px',
            marginBottom: isMobile ? '4px' : '0',
          }}
        />
      ))}
      {activeFilters.length > 1 && (
        <Chip
          label="Clear All"
          onClick={clearFilters}
          deleteIcon={<ClearIcon />}
          style={{
            backgroundColor: '#ff6b6b',
            color: 'white',
            height: isMobile ? 22 : 25,
            fontSize: isMobile ? '0.7rem' : '0.8125rem',
            cursor: 'pointer',
            marginBottom: isMobile ? '4px' : '0',
          }}
        />
      )}
    </Box>
  );
};

export default AppliedFilters; 